import { StorageFactory } from '../../../storageFactory'
import { authenticateWidget, loginGuestUser, loginUnmudlUser, loginCourseReportingWidgetUser,
  navigateToCareerProspect, populatePlanningStreamWithStructure, getProgramCatalogs,
  addCatalogToPlanningStream, getCourseProgramProgress, updateCourseProgramProgress,
  getWidgetIntroductionMessage, getWidgetDemoWidget } from '../api'

export const storageFactory = () => {
  return StorageFactory(() => localStorage)
}

export const loadAuthenticateWidget = ({ state, commit }, {key, secret, type}) => {
  return authenticateWidget(key, secret, type)
}

export const loadWidgetIntroductionMessage = ({ state, commit }, {key, secret, type}) => {
  return getWidgetIntroductionMessage(key, secret, type)
}

export const loadWidgetDemoWidget = ({ state, commit }, {key, secret, type}) => {
  return getWidgetDemoWidget(key, secret, type)
}

export const loadLoginGuestUser = ({ state, commit }, {institutionId, isWidgetAdminDash}) => {
  return loginGuestUser(institutionId).then(token => {
    if (!isWidgetAdminDash) {
      let localStore = storageFactory()
      localStore.setItem('token', token)
      localStore.setItem('userrole', 'Guest')
      let uObj = {
        institutionId: institutionId
      }
      localStore.setItem('userobj', JSON.stringify(uObj))
    }
    return token
  })
}

export const loadLoginUnmudlUser = ({ state, commit }, { institutionId, data }) => {
  let localStore = storageFactory()
  return loginUnmudlUser(institutionId, data).then(userObj => {
    let token = userObj.password
    localStore.setItem('token', token)
    let role = userObj.roles[0].role
    localStore.setItem('userrole', role)
    localStore.setItem('userobj', JSON.stringify(userObj))
    return userObj
  })
}

export const loadLoginCourseReportingWidgetUser = ({ state, commit }, { institutionId, data }) => {
  let localStore = storageFactory()
  return loginCourseReportingWidgetUser(institutionId, data).then(userObj => {
    let token = userObj.password
    localStore.setItem('token', token)
    let role = userObj.roles[0].role
    localStore.setItem('userrole', role)
    localStore.setItem('userobj', JSON.stringify(userObj))
    localStore.setItem('userFullName', userObj.firstName + ' ' + userObj.lastName)
    localStore.setItem('userid', userObj.uuid)
    return userObj
  })
}

export const loadCourseProgramProgress = ({ state, commit }, { courseId, institutionId }) => {
  return getCourseProgramProgress(courseId, institutionId)
}

export const loadUpdateCourseProgramProgress = ({ state, commit }, { streamId, programId }) => {
  return updateCourseProgramProgress(streamId, programId)
}

export const loadNavigateToCareerProspect = ({ state, commit }, token) => {
  return navigateToCareerProspect(token)
}

export const loadPlanningStreamWithStructure = ({ state, commit }, userId) => {
  return populatePlanningStreamWithStructure(userId).then(data => {
    if (data !== undefined) {
      commit('LOAD_PLANNING_STREAM', data)
    }
    return data
  })
}

export const loadProgramCatalogs = ({ state, commit }, programId) => {
  return getProgramCatalogs(programId)
}

export const loadAddCatalogToPlanningStream = ({ state, commit }, { uuid, entity }) => {
  return addCatalogToPlanningStream(uuid, entity)
}



// WEBPACK FOOTER //
// ./src/app/widget/vuex/actions.js